import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreeViewComponent } from '@shared/tree-view/tree-view.component';
import { TaxonomyAttributeValue } from 'src/app/features/safety-recommendations/model/taxonomy-attribute-values-entity';

@Component({
  selector: 'app-attr-value-selection-tree-dialog',
  templateUrl: './attr-value-selection-tree-dialog.component.html',
  styleUrls: ['./attr-value-selection-tree-dialog.component.scss']
})
export class AttrValueSelectionTreeDialogComponent {

  @Input() showValues: TaxonomyAttributeValue[];
  @Input() title: string;
  @Input() description: string;
  identifier: number;

  selectedElement: any;

  @ViewChild('treeView', { static: false }) treeView: TreeViewComponent;

  constructor(
    public dialogRef: MatDialogRef<AttrValueSelectionTreeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  save(): void {
    this.dialogRef.close({selectedElement: this.selectedElement});
  }

  cancel(): void {
    this.dialogRef.close();
  }

  selectedElementChanged($event): void {
    const [ index, parent, item ] = $event;
    item.path = this.generatePath(index[0], parent);
    this.selectedElement = item;
  }

  generatePath(index, parent): string {
    let path = '';
    for (const i of index.split('_')) {
      parent = parent.children ? parent.children[i] : parent[i];
      path = path + parent.description + ' > ';
    }
    return path.slice(0, -3);
  }

  confirmSelection(): void {
    this.save();
  }

}
